import conditionLevels from "../../../model-constants/product/conditionLevels";
import {
    PRESET_TYPE_BRAND,
    PRESET_TYPE_CONDITION_LEVEL
} from "../../../model-constants/product-filter-group/presetTypes";

export default function getFilterableAttributes(
    attributeRelations
) {
    const productAttributes = attributeRelations.product_attribute;

    const brands = attributeRelations.brand;

    const brandAttributes = brands.map(brand => ({
        id: brand.id,
        group_id: PRESET_TYPE_BRAND,
        name: brand.name,
        sort_order: brand.sort_order
    }));

    const conditionLevelAttributes = conditionLevels.items.map((item, index) => ({
        id: item.value,
        group_id: PRESET_TYPE_CONDITION_LEVEL,
        name: item.label,
        sort_order: index
    }));

    return productAttributes
        .concat(brandAttributes)
        .concat(conditionLevelAttributes);
}


function createGroupId(productFilterGroup) {
    if (productFilterGroup.product_attribute_group_id !== null) {
        return productFilterGroup.product_attribute_group_id;
    }

    return productFilterGroup.preset_type;
}
